export default "/assets/569bf2a1150fe5b4.svg"